import React from 'react';

export const RequestChainImage = () => {
    return (
        <svg
            width="372"
            height="140"
            viewBox="0 0 372 140"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M155 55.1182L123 101.118"
                stroke="#BED2FF"
                strokeWidth="2"
                strokeDasharray="8 8"
            />
            <path
                d="M245.5 79.6182L130 108.118"
                stroke="#BED2FF"
                strokeWidth="2"
                strokeDasharray="8 8"
            />
            <path
                d="M182 50.6182L247 74.1182"
                stroke="#BED2FF"
                strokeWidth="2"
                strokeDasharray="8 8"
            />
            <path
                d="M163.5 38.1182C170.975 38.1182 177.693 39.6075 182.505 41.9697C187.382 44.364 190 47.4827 190 50.6182C190 53.7536 187.382 56.8723 182.505 59.2666C177.693 61.6289 170.975 63.1182 163.5 63.1182C156.025 63.1182 149.307 61.6289 144.495 59.2666C139.618 56.8723 137 53.7536 137 50.6182C137 47.4827 139.618 44.364 144.495 41.9697C149.307 39.6075 156.025 38.1182 163.5 38.1182Z"
                fill="#DEE6FD"
                stroke="#BED2FF"
                strokeWidth="2"
            />
            <path
                d="M111.5 95.1182C118.699 95.1182 125.167 96.5514 129.798 98.8232C134.494 101.127 137 104.121 137 107.118C137 110.115 134.494 113.109 129.798 115.413C125.167 117.685 118.699 119.118 111.5 119.118C104.301 119.118 97.8333 117.685 93.2021 115.413C88.5057 113.109 86 110.115 86 107.118C86 104.121 88.5057 101.127 93.2021 98.8232C97.8333 96.5514 104.301 95.1182 111.5 95.1182Z"
                fill="#DEE6FD"
                stroke="#BED2FF"
                strokeWidth="2"
            />
            <path
                d="M265.5 62.1182C273.527 62.1182 280.745 63.7196 285.919 66.2627C291.157 68.8376 294 72.206 294 75.6182C294 79.0303 291.157 82.3987 285.919 84.9736C280.745 87.5167 273.527 89.1182 265.5 89.1182C257.473 89.1182 250.255 87.5167 245.081 84.9736C239.843 82.3987 237 79.0303 237 75.6182C237 72.206 239.843 68.8376 245.081 66.2627C250.255 63.7196 257.473 62.1182 265.5 62.1182Z"
                fill="#DEE6FD"
                stroke="#BED2FF"
                strokeWidth="2"
            />
            <path
                d="M279 56.9726L265.61 64.754L252.133 56.9728L265.523 49.1914L279 56.9726Z"
                fill="white"
            />
            <path
                d="M265.61 64.754L252.133 56.9728L252.082 74.7125L265.56 82.4937L278.95 74.7123L279 56.9727L265.61 64.754Z"
                fill="#DEE6FD"
            />
            <path
                d="M262.446 69.9769L262.416 80.662L254.298 75.9751L254.328 65.29L262.446 69.9769Z"
                fill="white"
            />
            <path d="M258.372 78.3441V67.625" stroke="#DEE6FD" strokeMiterlimit="10" />
            <path
                d="M252.13 56.9277L265.619 64.7154L258.707 69.7795L245.219 61.9919L252.13 56.9277Z"
                fill="#676DFD"
            />
            <path
                d="M278.999 56.9726L265.522 49.1914L252.17 56.9508L252.13 56.9279L245.218 61.992L252.106 65.9689L252.081 74.7124L265.559 82.4937L278.949 74.7123L278.999 56.9726Z"
                stroke="#333333"
                strokeMiterlimit="10"
            />
            <path
                d="M278.999 56.9726L265.522 49.1914L252.13 56.9279L245.218 61.992L252.106 65.9689L252.081 74.7124L265.559 82.4937L278.949 74.7123L278.999 56.9726Z"
                stroke="#333333"
                strokeMiterlimit="10"
            />
            <path
                d="M177.782 31.8994L164.392 39.6808L150.914 31.8995L164.304 24.1182L177.782 31.8994Z"
                fill="white"
            />
            <path
                d="M164.392 39.6808L150.914 31.8996L150.864 49.6392L164.341 57.4205L177.731 49.6391L177.782 31.8994L164.392 39.6808Z"
                fill="#DEE6FD"
            />
            <path
                d="M161.228 44.9037L161.197 55.5887L153.079 50.9019L153.11 40.2168L161.228 44.9037Z"
                fill="white"
            />
            <path d="M157.153 53.2708V42.5518" stroke="#DEE6FD" strokeMiterlimit="10" />
            <path
                d="M150.912 31.8545L164.4 39.6422L157.489 44.7063L144 36.9186L150.912 31.8545Z"
                fill="#676DFD"
            />
            <path
                d="M177.781 31.8994L164.303 24.1182L150.951 31.8776L150.912 31.8546L144 36.9188L150.888 40.8956L150.863 49.6392L164.341 57.4204L177.731 49.639L177.781 31.8994Z"
                stroke="#333333"
                strokeMiterlimit="10"
            />
            <path
                d="M177.781 31.8994L164.303 24.1182L150.912 31.8546L144 36.9188L150.888 40.8956L150.863 49.6392L164.341 57.4204L177.731 49.639L177.781 31.8994Z"
                stroke="#333333"
                strokeMiterlimit="10"
            />
            <path
                d="M125.782 87.8994L112.392 95.6808L98.9142 87.8995L112.304 80.1182L125.782 87.8994Z"
                fill="white"
            />
            <path
                d="M112.392 95.6808L98.9142 87.8996L98.8638 105.639L112.341 113.42L125.731 105.639L125.782 87.8994L112.392 95.6808Z"
                fill="#DEE6FD"
            />
            <path
                d="M109.228 100.904L109.197 111.589L101.08 106.902L101.11 96.2168L109.228 100.904Z"
                fill="white"
            />
            <path d="M105.153 109.271V98.5518" stroke="#DEE6FD" strokeMiterlimit="10" />
            <path
                d="M98.9117 87.8545L112.4 95.6422L105.489 100.706L92.0001 92.9186L98.9117 87.8545Z"
                fill="#676DFD"
            />
            <path
                d="M125.781 87.8994L112.303 80.1182L98.9513 87.8776L98.9116 87.8546L92 92.9188L98.888 96.8956L98.8631 105.639L112.341 113.42L125.731 105.639L125.781 87.8994Z"
                stroke="#333333"
                strokeMiterlimit="10"
            />
            <path
                d="M125.781 87.8994L112.303 80.1182L98.9116 87.8546L92 92.9188L98.888 96.8956L98.8631 105.639L112.341 113.42L125.731 105.639L125.781 87.8994Z"
                stroke="#333333"
                strokeMiterlimit="10"
            />
        </svg>
    );
};
